<template>
  <div class="Controls__Container">
    <div
      class="Controls__Window"
      v-if="open"
    >
      <div
        class="Controls__Title"
        @click="OpenClose()"
      >
        <div class="Controls__Arrow" />
        <p class="Controls__Title_Text">
          {{ $t('control-panel') }}
        </p>
        <div class="Controls__Burger" />
      </div>
      <ControlsShape v-show="step === 1" />
      <ControlsTexture v-show="step === 2" />
    </div>
    <div
      v-if="!open"
      class="Controls_Popup"
      @click="OpenClose()"
    >
      <div class="Controls_Popup_Icon" />
    </div>
    <ControlsZoom class="Controls__Zoom" />
  </div>
</template>

<script>
import ControlsShape from './components/ControlsShape'
import ControlsTexture from './components/ControlsTexture'
import ControlsZoom from './components/ControlsZoom'
import { mapGetters } from 'vuex'
import { EventBus } from '@/event-bus.js'

export default {
  data () {
    return {
      open: true
    }
  },
  components: {
    ControlsShape,
    ControlsTexture,
    ControlsZoom
  },
  computed: {
    ...mapGetters(['step'])
  },
  methods: {
    OpenClose () {
      this.open = !this.open
    }
  },
  mounted () {
    EventBus.$on('PointActivated', () => {
      this.open = true
    })
  },
  beforeDestroy () {
    EventBus.$off('PointActivated')
  }
}
</script>

<style scoped>
.Controls__Container {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    pointer-events: none;
}

@media screen and (max-width: 1300px) {
  .Controls__Window {
    margin-top: 18em;
    align-self: flex-end;
    margin-right: 50px;
    background: white;
    border-radius: 5px;
    box-shadow: 0px 3px 5px -1px rgba(0,0,0,0.2), 0px 6px 10px 0px rgba(0,0,0,0.14), 0px 1px 18px 0px rgba(0,0,0,0.12);
    width: 230px;
    height: auto;
    display: flex;
    flex-direction: column;
    pointer-events: auto;
  }

  .Controls_Popup {
    margin-top: 18em;
    width: 42px;
    height: 42px;
    align-self: flex-end;
    margin-right: 55px;
    background: black;
    display: flex;
    justify-content: center;
    border-radius: 100%;
    pointer-events: auto;
    box-shadow: 0px 3px 5px -1px rgba(0,0,0,0.2), 0px 6px 10px 0px rgba(0,0,0,0.14), 0px 1px 18px 0px rgba(0,0,0,0.12);
  }

  .Controls__Title_Text {
  font-size: 0.8em;
  color: white;
}
.Controls__Zoom {
  position: absolute;
  margin-top: 9em;
  align-self: flex-end;
  margin-right: 55px;
}

.Controls__Burger {
  position: absolute;
  right: 0.9em;
  top: 6px;
  background: white;
  margin-top: auto;
  margin-bottom: auto;
  width: 20px;
  height: 20px;
  mask-repeat: no-repeat;
  mask-position: center;
  mask-size: contain;
  mask-image: url('../../assets/icons/menu.svg');
}

}

@media screen and (min-width: 1300px) {
  .Controls__Window {
    margin-top: 24em;
    align-self: flex-end;
    margin-right: 50px;
    background: white;
    border-radius: 5px;
    box-shadow: 0px 3px 5px -1px rgba(0,0,0,0.2), 0px 6px 10px 0px rgba(0,0,0,0.14), 0px 1px 18px 0px rgba(0,0,0,0.12);
    width: 280px;
    height: auto;
    display: flex;
    flex-direction: column;
    pointer-events: auto;
  }

  .Controls_Popup {
    margin-top: 24em;
    width: 55px;
    height: 55px;
    align-self: flex-end;
    margin-right: 55px;
    background: black;
    display: flex;
    justify-content: center;
    border-radius: 100%;
    pointer-events: auto;
    box-shadow: 0px 3px 5px -1px rgba(0,0,0,0.2), 0px 6px 10px 0px rgba(0,0,0,0.14), 0px 1px 18px 0px rgba(0,0,0,0.12);
  }

  .Controls__Title_Text {
  font-size: 1em;
  color: white;
}
.Controls__Zoom {
  position: absolute;
  margin-top: 9em;
  align-self: flex-end;
  margin-right: 58px;
}

.Controls__Burger {
  position: absolute;
  right: 1.2em;
  top: 6px;
  background: white;
  margin-top: auto;
  margin-bottom: auto;
  width: 20px;
  height: 20px;
  mask-repeat: no-repeat;
  mask-position: center;
  mask-size: contain;
  mask-image: url('../../assets/icons/menu.svg');
}

}

.Controls__Title {
  padding: 10px;
  display: flex;
  justify-content: center;
  background: black;
  border-radius: 5px 5px 0px 0px;
  position: relative;
}

.Controls_Popup_Icon {
  width: 45%;
  height: 45%;
  margin: auto;
  background: white;
  mask-repeat: no-repeat;
  mask-position: center;
  mask-size: contain;
  mask-image: url('../../assets/icons/tune.svg');
}

.Controls__Arrow {
  position: absolute;
  left: -10px;
  top: 8px;
  background: black;
  margin-top: auto;
  margin-bottom: auto;
  width: 15px;
  height: 15px;
  mask-repeat: no-repeat;
  mask-position: center;
  mask-size: contain;
  mask-image: url('../../assets/icons/triangle.svg');
  transform: rotate(31deg);
}
</style>
